export const SESSION_REFRESH_TIMEOUT_MS = 8000
export const SESSION_BOOTSTRAP_TIMEOUT_MS = 2000
export const REQUEST_SESSION_REFRESH = 'request-session-refresh'
export const RECEIVE_SESSION = 'receive-session'
export const SESSION_RECEIVED = 'session-received'
export const SESSION_QUERY_PARAM = 'session'
export const STOREFRONT_SESSION_SIGNAL = 'storefront'
